export default "__VITE_ASSET__f7b64e04__"